<p-confirmDialog></p-confirmDialog>

<div class="flex justify-between py-6 border-b border-neutral-base">
  <span class="text-[18px] font-black">
    <i
      [class.pi]="true"
      [class.pi-file-check]="true"
      style="font-size: 2rem"></i>
    REVISION DE DESPLIEGUE DE SISTEMA
  </span>

  <div
    *ngIf="!isChief()"
    class="flex gap-3">
    <button
      type="button"
      class="text-[16px] text-primary-base underline bg-transparent border-none pr-2 font-semibold cursor-pointer"
      (click)="backPage()">
      Cancelar
    </button>
    <app-buttons
      [label]="'Sugerir subsanacion'"
      [classes]="'text-primary-base border border-primary-base'"
      [disabled]="readonlyReview"
      [attr.title]="readonlyReview ? 'La revision ya fue registrada y no puede modificarse.' : null"
      (click)="confirm('CORRECTION')" />

    <app-buttons
      [label]="'Aprobar'"
      [classes]="'bg-primary-base text-primary-light'"
      [disabled]="readonlyReview"
      [attr.title]="readonlyReview ? 'La revision ya fue registrada y no puede modificarse.' : null"
      (click)="confirm('APPROVED')" />
  </div>

  <div
    *ngIf="isChief()"
    class="flex gap-3">
    <app-buttons
      [label]="'Cancelar'"
      (click)="backPage()" />
    <app-buttons
      [label]="'Subsanar'"
      [classes]="'text-primary-base border border-primary-base'"
      [disabled]="readonlyReview"
      [attr.title]="readonlyReview ? 'La revision ya fue registrada y no puede modificarse.' : null"
      (click)="confirm('CORRECTION')" />
    <div
      [attr.title]="
        hasMarkedFields() ? 'Para enviar a aprobación no deben quedar campos seleccionados para subsanación.' : null
      ">
      <app-buttons
        [label]="'Enviar a aprobacion'"
        [classes]="'bg-primary-base text-primary-light'"
        [disabled]="readonlyReview || hasMarkedFields()"
        (click)="confirm('APPROVED')" />
    </div>
  </div>
</div>

<div class="flex flex-col gap-10">
  <div
    *ngIf="detailDeploySystem"
    class="flex flex-col gap-2 mt-8">
    <div class="flex flex-col gap-2 py-4">
      <span class="text-[24px] font-bold mb-2">Revisa todos los campos del despliegue del sistema</span>
      <div
        *ngIf="readonlyReview"
        class="flex flex-col gap-6 text-[16px] leading-7">
        <span>
          Estás consultando una revisión previamente registrada del despliegue del sistema. Desde esta vista es posible
          revisar los campos observados durante el proceso de revisión, así como consultar el histórico completo de
          revisiones realizadas por los distintos perfiles revisores.
        </span>

        <span>
          El histórico muestra los comentarios asociados a cada revisión y el estado propuesto para el despliegue del
          sistema en cada fase del proceso de aprobación. La información se presenta en modo solo lectura y no permite
          realizar modificaciones sobre la revisión enviada.
        </span>
      </div>
      <div
        *ngIf="!readonlyReview && !isChief()"
        class="flex flex-col gap-6 text-[16px]">
        <span>
          Añade los comentarios que consideres necesarios sobre la revision. Al finalizar, se aplicara una de estas dos
          opciones segun tu accion:
        </span>
        <div class="flex flex-col gap-4 pl-4 text-neutral-dark">
          <span>
            &bull;
            <strong class="text-black text-[16px]">Finalizar revisión:</strong>
            el sistema desplegado pasará a la siguiente fase, donde será evaluado por el grupo de revisores
            correspondiente.
          </span>
          <span>
            &bull;
            <strong class="text-black text-[16px] font-semibold">Subsanar despliegue:</strong>
            el solicitante deberá revisar y corregir los campos indicados antes de volver a solicitar la aprobacion.
          </span>
        </div>
        <span class="text-neutral-dark text-[16px]">
          Ten en cuenta que los comentarios que escribas podrán ser visibles para otros revisores a medida que avance el
          flujo de revisión.
        </span>
      </div>
      <div
        *ngIf="!readonlyReview && isChief()"
        class="text-[16px]">
        Selecciona los campos que consideres incorrectos o que requieran revisión por parte de la persona que solicita
        el despliegue del sistema. Es posible que algunos campos ya aparezcan seleccionados, ya que han sido marcados
        previamente por otros revisores. Para poder enviar el sistema a aprobación, no puede haber ningún campo marcado.
      </div>
    </div>

    <div
      *ngIf="!readonlyReview"
      class="flex flex-col gap-2">
      <span class="text-xl font-bold mt-4">Comentario sobre la revision</span>
      <span class="text-[16px] font-normal">Comentarios</span>
      <span class="text-[16px] text-neutral-dark">
        Los comentarios que escribas en este apartado se mostraran en el turno de revision de cada revisor.
      </span>
      <textarea
        class="w-full min-h-[160px] border border-neutral-base rounded p-3"
        [disabled]="readonlyReview"
        [(ngModel)]="reviewComment"></textarea>
    </div>

    <div
      class="flex flex-col mt-8"
      *ngIf="shouldShowReviewComments">
      <app-review-comments-block [comments]="reviewComments"></app-review-comments-block>
    </div>

    <div class="flex flex-col gap-10 mt-10">
      <div class="flex flex-col gap-6">
        <span class="text-[18px] font-bold">Datos funcionales del despliegue</span>

        <div class="grid grid-cols-2 gap-4">
          <div class="flex flex-col">
            <span class="text-[14px] text-neutral-dark">Proyecto asociado</span>
            <span class="text-md font-normal">
              {{ detailDeploySystem.projectAssociated || '-' }}
            </span>
          </div>

          <div class="flex flex-col">
            <span class="text-[14px] text-neutral-dark">Tipo de sistema</span>
            <span class="text-md font-normal">
              {{ getSystemTypeLabel(detailDeploySystem.systemType) }}
            </span>
          </div>

          <div class="flex flex-col">
            <span class="text-[14px] text-neutral-dark">Fecha estimada de despliegue del sistema</span>
            <span class="text-md font-normal">
              {{ detailDeploySystem.estimatedDeployDate || '-' }}
            </span>
          </div>
        </div>

        <div class="flex flex-col gap-2">
          <span class="text-[14px] text-neutral-dark">Funciones o tareas a las que da soporte el sistema</span>

          <div class="flex flex-wrap gap-4">
            @for (func of detailDeploySystem.functions || []; track func) {
              <app-pill
                [value]="getFunctionLabel(func)"
                [classe]="'c-pill--primary'" />
            }
          </div>
        </div>

        <div class="flex flex-col gap-2">
          <span class="text-sm text-neutral-dark">Descripcion del funcionamiento del sistema</span>

          <span class="text-md font-normal whitespace-pre-line">
            {{ detailDeploySystem.description || '-' }}
          </span>
        </div>
      </div>

      <app-system-deploy-ria-compliance
        [riaData]="detailDeploySystem"
        [reviewMode]="true"
        [readonlyReview]="readonlyReview"
        [showPreviousReviewIndicators]="shouldShowPreviousReviewIndicators()" />
      <app-system-deploy-technical-issues
        [technicalIssuesData]="detailDeploySystem"
        [reviewMode]="true"
        [readonlyReview]="readonlyReview"
        [showPreviousReviewIndicators]="shouldShowPreviousReviewIndicators()" />
      <app-system-deploy-iso-compliance
        [isoData]="detailDeploySystem"
        [reviewMode]="true"
        [readonlyReview]="readonlyReview"
        [showPreviousReviewIndicators]="shouldShowPreviousReviewIndicators()" />
      <app-system-deploy-hap-compliance
        [hapData]="detailDeploySystem"
        [reviewMode]="true"
        [readonlyReview]="readonlyReview"
        [showPreviousReviewIndicators]="shouldShowPreviousReviewIndicators()" />
      <app-system-deploy-economic-data
        [economicData]="detailDeploySystem"
        [reviewMode]="true"
        [readonlyReview]="readonlyReview"
        [showPreviousReviewIndicators]="shouldShowPreviousReviewIndicators()" />
      <app-system-deploy-impact-evaluation
        [impactData]="detailDeploySystem"
        [reviewMode]="true"
        [readonlyReview]="readonlyReview"
        [showPreviousReviewIndicators]="shouldShowPreviousReviewIndicators()" />
      <app-system-deploy-risk-management
        [riskData]="detailDeploySystem"
        [reviewMode]="true"
        [readonlyReview]="readonlyReview"
        [showPreviousReviewIndicators]="shouldShowPreviousReviewIndicators()" />
    </div>
  </div>
</div>
